<mat-toolbar [color]="color" [ngStyle]="styles">
	<ng-content></ng-content>
</mat-toolbar>
